<template>
  <div class='window scroll'>
      <div class="user__block">
        <h2>Список пользователей</h2>
        
          
        <router-link :to="{path: '/personal'}"> <h2> Моя страница </h2></router-link> 
        
        <table>

          <tr @click="$router.push({path:`/personal/user/${user.id}`})" class='user__item' v-for="user in filteredPerson" :key="user.id" >
              <td class='tr_first'>   
                <img width="50px" :src="user.avatar" alt="">
              </td>
              <td class='tr_middle'>
              
                 {{user.last_name}} {{user.first_name}} 
     
              </td>
              <td class='tr_last'>
                {{user.email}}
              </td>
          </tr>
       </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    },
  name: "Users",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getPersons", 'getPerson']),
    filteredPerson() {
      return this.getPersons.filter(obj => obj.post)
    },
  },
  methods: {
    ...mapActions(["fetchPersons", 'fetchPerson']),
  },
  mounted() {
    this.fetchPersons();
    this.fetchPerson();
  },
};
</script>


<style scoped>
a, a:visited {
  color: white;
  margin: 0 auto;
}

a:hover {
  color: rgb(235, 217, 20);
}

.window{
  height: 100%;
  overflow: auto;
}

.user__block {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 30px;
}

h2 {
  margin: 0 auto;
  margin-bottom: 20px;
}

table {
  padding: 40px;
  margin: 0 auto;
  width: max-content;
  border-collapse: collapse;
  cursor: pointer;
}

.user__item__me{
  border-color: red;
}

img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid var(--reverse-hover);
  padding: 3px;
  background-color: transparent;
}

td {
  padding: 6px;
}

tr:hover {
  background-color: var(--body-bg);
  color: var(--reverse-hover);
}
 
.tr_first {
  width: 130px;
  padding-left: 30px;
}

.tr_middle {
width: 250px
}

.tr_last {
padding-right: 30px;
}
.scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scroll::-webkit-scrollbar-track {
  background: var(--secondary-hover);
}
.scroll::-webkit-scrollbar-thumb {
  background-color: var(--secondary);
  border: 2px solid var(--secondary-hover); 
}


@media (max-width: 767px) {

  table {
    padding: 10px;
    margin: 0 auto;
    width: 100%;
    font-size: 12px;
  }

  .user__block {
    height: 100%;
    padding: 0px;
  }

  .tr_first {
    width: auto;
    padding-left: 5px;
  }

  .tr_middle {
  width: auto;
  }

  .tr_last {
  padding-right: 5px;
  }
}

</style>
